import React from "react";

const Address = () => {
  return (
    <>
      <div className="container my-5">
        <div className="row">
          <div className="col-lg-4 col-12">
            <h4>Singapore</h4>
            <p className="address-contact">
              6 Yio Chu Kang Rd, Singapore 545521
            </p>
          </div>
          <div className="col-lg-4 col-12">
            <h4>China</h4>
            <p className="address-contact">
              23 Xingnan Road, Wuzhong District, China
            </p>
          </div>
          {/* <div className="col-lg-4 col-12">
            <h4>Vietnam</h4>
            <p className="address-contact">
              Floor 9, 42 Tu Cuong, Ward 4, Tan Binh District, Ho Chi Minh
            </p>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Address;
